import { PropsWithChildren, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { RefreshCcwIcon } from "lucide-react";

export function ErrorBoundaryPage({ children }: PropsWithChildren) {
  const onReload = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Sentry.ErrorBoundary
      fallback={
        <div className="min-h-[calc(100vh-10rem)] lg:min-h-[calc(100vh-8.5rem)] flex flex-col items-center justify-center w-full p-4">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-4">
              Something went wrong
            </h1>
            <p className="text-muted-foreground mb-4">
              An unexpected error occurred
            </p>
          </div>
          <div className="flex items-center justify-center w-full mt-8">
            <button
              onClick={onReload}
              className="bg-primary text-primary-foreground px-4 py-2 rounded-md inline-flex items-center"
            >
              <RefreshCcwIcon className="w-4 h-4 mr-2" />
              Reload
            </button>
          </div>
        </div>
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
